import { render, staticRenderFns } from "./histRecord.vue?vue&type=template&id=151a113a&scoped=true&"
import script from "./histRecord.vue?vue&type=script&lang=js&"
export * from "./histRecord.vue?vue&type=script&lang=js&"
import style0 from "./histRecord.vue?vue&type=style&index=0&id=151a113a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "151a113a",
  null
  
)

export default component.exports